import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { signOutAPI } from "../../store/actions";

const { menuItems } = require('./MenuItems');

const Menu = (props) => {
  const list = menuItems(props).map((menuItem) => {
    const Icon = menuItem.icon;
    const isActive = menuItem.step && menuItem.step === props.activeStep;
    return (
      <li key={menuItem.name}>
        <Item
          type="button"
          onClick={menuItem.onClick}
          $active={isActive}
          $muted={!menuItem.step}
          aria-current={isActive ? "page" : undefined}
        >
          <Icon size={20} weight={isActive ? "fill" : "regular"} />
          <span>{menuItem.name}</span>
        </Item>
      </li>
    );
  });
  return (
    <List>{list}</List>
  )
};

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 4px;

  li:last-child {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgb(254 254 254 / 0.12);
  }
`;

export const Item = styled.button`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 46px;
  padding: 0 16px;
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: rgb(254 254 254 / 0.8);
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition:
    background-color 0.25s ease,
    color 0.2s ease,
    transform 0.3s var(--ease-out);

  &:hover {
    background: rgb(254 254 254 / 0.08);
    color: #fefefe;
    transform: translateX(2px);
  }

  ${({ $active }) =>
    $active &&
    css`
      background: rgb(254 254 254 / 0.12);
      color: var(--butter);

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 12px;
        bottom: 12px;
        width: 3px;
        border-radius: 3px;
        background: var(--coral);
      }
    `}

  ${({ $muted }) =>
    $muted &&
    css`
      color: rgb(254 254 254 / 0.62);
    `}
`;

const mapStateToProps = (state) => {
  return {
    user: state.userState.user,
    profile: state.profileState.profile,
  };
};

const mapDipatchToProps = (dispatch) => ({
  signOut: () => dispatch(signOutAPI()),
});

export default connect(mapStateToProps, mapDipatchToProps)(Menu);
